export default "__VITE_ASSET__2294cb57__"